export const editableFieldsList = [];
export const fieldNameDropDown = [];
export const dropDownMenuUrls = [];

export const reportColumnsDefinitions = [
    // main
    {
        label: 'Hour',
        field: 'hour',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Date',
        field: 'date',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: true,
    }
    ,
    {
        label: 'Week',
        field: 'week',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: true,
    }
    ,
    {
        label: 'Month',
        field: 'month',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: true,
    }
    ,
    {
        label: 'Quarter',
        field: 'quarter',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: true,
    }
    ,
    {
        label: 'Year',
        field: 'year',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: true,
    }
    ,
    {
        label: 'Market',
        field: 'marketName',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Site',
        field: 'siteName',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Network',
        field: 'networkName',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Site Group',
        field: 'siteGroupName',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Source',
        field: 'sourceName',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Partner',
        field: 'partnerNames',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Device',
        field: 'deviceName',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Campaign',
        field: 'campaign',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Adgroup',
        field: 'adgroup',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        defaultSorting: false,
        isCompareColumn: false,
    }
    ,

    // metrics
    {
        label: 'Impressions',
        field: 'boughtImpressions',
        sign: '',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Bought',
        field: 'boughtClicks',
        sign: '',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    }
    ,
    {
        label: 'adCTR',
        field: 'adCtr',
        sign: '%',
        width: '110px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'float',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Cost',
        field: 'costs',
        sign: '$',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'float',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    }
    ,
    {
        label: 'CPC',
        field: 'cpc',
        sign: '$',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'float',
            precision: 4
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Sold',
        field: 'soldClicks',
        sign: '',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Revenue',
        field: 'revenue',
        sign: '$',
        width: '120px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'float',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    }
    ,
    {
        label: 'opCTR',
        field: 'opCtr',
        sign: '%',
        width: '110px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'float',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    }
    ,
    {
        label: 'RPS',
        field: 'rps',
        sign: '$',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'float',
            precision: 4
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    }
    ,
    {
        label: 'RPC',
        field: 'rpc',
        sign: '$',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'float',
            precision: 4
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    }
    ,
    {
        label: 'RevGap',
        field: 'revGap',
        sign: '$',
        width: '110px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'float',
            precision: 4
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Profit',
        field: 'profit',
        sign: '$',
        width: '100px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'float',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    }
    ,
    {
        label: 'Margin',
        field: 'margin',
        sign: '%',
        width: '110px',
        classes: 'cost-clicks-column',
        filter: true,
        sort: true,
        format: {
            type: 'float',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    }
];



// WEBPACK FOOTER //
// ./src/configs/hourly-partners-report-config.js